import React, { useState } from "react";

import { Form, Button, Col, Row } from "react-bootstrap";
import Rq from "../../NewComponents/RQ";
import DocUpload from "../DocUpload/DocUpload";
import { MonthYearData } from "../../../shared/util/vars";

function MonthlyReportsForm(props) {

  const [File, setFile] = useState();
  const [FilePath, setFilePath] = useState("");

  return (
    <div>
      <h2 id="role-form-title">Add MonthlyReports Details</h2>
      <div id="role-form-outer-div">
        <Form id="form">
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Select Month & Year
            </Form.Label>
            <Col sm={10} className="form-input">
              <Form.Control
                as="select"
                required
                onChange={(e) => props.HandleOtherText(e, "ym")}>
                {MonthYearData.map((options, id) => (
                  <option key={id} value={options.value}>
                    {options.option}
                  </option>
                ))}
              </Form.Control>
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              File URL
            </Form.Label>
            <Col sm={7} className="form-input">
              <Form.Control
                disabled
                type="Text"
                placeholder="FilePath "
                required
                value={props.FileLink}
              />
            </Col>
            <Col sm={3} className="form-input">
              <DocUpload
                center
                id="document"
                HandleOtherText={props.HandleOtherText}
                File={File}
                setFile={setFile}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              Report Text
            </Form.Label>
            <Col sm={10} className="form-input">
              <Rq HandleRQText={props.HandleRQText} RQ={props.RQ} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-submit-button">
            <Col sm={{ span: 10, offset: 2 }}>
              <Button onClick={props.SubmitReport}>Submit</Button>
            </Col>
          </Form.Group>
          <Form.Group as={Row} id="form-cancel-button">
            <Col sm={{ span: 10, offset: 2 }} id="form-cancel-button-inner">
              <Button type="reset" onClick={props.onFormClose}>
                cancel
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
}

export default MonthlyReportsForm;
